import React from 'react';
import ReactDOM from 'react-dom';
import IPhoneGrid from './IPhoneGrid';

ReactDOM.render(
  <React.StrictMode>
    <IPhoneGrid />
  </React.StrictMode>,
  document.getElementById('root')
);